import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSource = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#0f1826",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M1.95836 9.2594C2.24191 9.93472 2.65604 10.5474 3.177 11.0622C3.69795 11.5771 4.31546 11.9839 4.99407 12.2595C5.67269 12.535 6.39905 12.6738 7.13145 12.6679C7.86386 12.662 8.58788 12.5115 9.26196 12.2251C9.93605 11.9386 10.5469 11.5218 11.0595 10.9987C11.5721 10.4755 11.9763 9.85622 12.2489 9.17642C12.5215 8.49662 12.6572 7.76967 12.6481 7.0373C12.6391 6.30493 12.4854 5.58156 12.1961 4.90872C11.9125 4.23341 11.4984 3.62074 10.9774 3.10591C10.4565 2.59107 9.83895 2.18419 9.16034 1.90864C8.48172 1.63308 7.75537 1.49427 7.02296 1.50018C6.29056 1.50609 5.56653 1.65659 4.89245 1.94305C4.21837 2.22952 3.6075 2.6463 3.09492 3.16947C2.58233 3.69264 2.17813 4.3119 1.90551 4.9917C1.63289 5.6715 1.49722 6.39845 1.50629 7.13082C1.51536 7.86319 1.66899 8.58656 1.95836 9.2594Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.0098 11.0176L14.4934 14.5",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.41113 5.53395C5.41113 5.97594 5.58671 6.39982 5.89924 6.71235C6.21178 7.02488 6.63566 7.20046 7.07765 7.20046C7.51964 7.20046 7.94352 7.02488 8.25605 6.71235C8.56859 6.39982 8.74417 5.97594 8.74417 5.53395C8.74417 5.09196 8.56859 4.66808 8.25605 4.35554C7.94352 4.04301 7.51964 3.86743 7.07765 3.86743C6.63566 3.86743 6.21178 4.04301 5.89924 4.35554C5.58671 4.66808 5.41113 5.09196 5.41113 5.53395Z",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.42393 9.70023C9.2541 9.21322 8.93696 8.79111 8.51647 8.49242C8.09598 8.19373 7.59298 8.03326 7.0772 8.03326C6.56142 8.03326 6.05842 8.19373 5.63794 8.49242C5.21745 8.79111 4.9003 9.21322 4.73047 9.70023",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSource;
